import { render, staticRenderFns } from "./SocialMediaListAll.vue?vue&type=template&id=6f15bf9a&"
import script from "./SocialMediaListAll.vue?vue&type=script&lang=js&"
export * from "./SocialMediaListAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports